const STAFF_CLINICAL_PATH_PREFIXES = [
  '/midwife',
  '/charting',
  '/shared-pregnancies',
  '/revenue-cycle',
];

export function isStaffClinicalPath(pathname = '') {
  const path = String(pathname || '');
  return STAFF_CLINICAL_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}
